module.exports = __webpack_public_path__ + "img/famen.8fb50926.png";